<template>
  <div class="login-container">
    <h1>微信扫码登录</h1>
    
    <div v-if="!isLoggedIn" class="qr-code-section">
      <div v-if="qrCodeUrl" class="qr-code-container">
        <iframe :src="qrCodeUrl" frameborder="0" width="300" height="400"></iframe>
        <p>请使用微信扫码登录</p>
      </div>
      <button v-else @click="getQrCode" class="login-button">获取登录二维码</button>
    </div>

    <div v-else class="user-info-section">
      <h2>登录成功！</h2>
      <div class="user-info">
        <img :src="userInfo.avatar" alt="头像" class="avatar" />
        <div class="info">
          <p><strong>昵称：</strong>{{ userInfo.nickname }}</p>
          <p><strong>性别：</strong>{{ userInfo.sex === 1 ? '男' : '女' }}</p>
          <p><strong>地区：</strong>{{ userInfo.province }} {{ userInfo.city }}</p>
        </div>
      </div>
      <button @click="logout" class="logout-button">退出登录</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      qrCodeUrl: '',
      state: '',
      isLoggedIn: false,
      userInfo: {}
    }
  },
  mounted() {
    // 检查URL参数中的state
    const urlParams = new URLSearchParams(window.location.search)
    const urlState = urlParams.get('state')
    if (urlState) {
      this.state = urlState
      this.checkLoginStatus()
    }
  },
  methods: {
    // 获取二维码
    getQrCode() {
      fetch('/dev-api/api/wechat/login')
        .then(response => response.json())
        .then(data => {
          this.qrCodeUrl = data.qrCodeUrl
          this.state = data.state
          // 开始轮询检查登录状态
          this.checkLoginStatus()
        })
        .catch(error => {
          console.error('获取二维码失败:', error)
        })
    },
    // 检查登录状态
    checkLoginStatus() {
      if (!this.state) return
      
      fetch(`/dev-api/api/wechat/check-login?state=${this.state}`)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.isLoggedIn = true
            this.userInfo = data.userInfo
            this.qrCodeUrl = ''
          } else {
            // 继续轮询
            setTimeout(() => this.checkLoginStatus(), 2000)
          }
        })
        .catch(error => {
          console.error('检查登录状态失败:', error)
          // 继续轮询
          setTimeout(() => this.checkLoginStatus(), 2000)
        })
    },
    // 退出登录
    logout() {
      this.isLoggedIn = false
      this.userInfo = {}
      this.qrCodeUrl = ''
      this.state = ''
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 30px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

h1 {
  color: #333;
  margin-bottom: 30px;
}

.qr-code-section {
  margin: 20px 0;
}

.qr-code-container {
  margin: 20px 0;
}

.login-button, .logout-button {
  background-color: #07C160;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px 0;
}

.login-button:hover, .logout-button:hover {
  background-color: #05A850;
}

.user-info-section {
  margin: 20px 0;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
}

.info {
  text-align: left;
}

.info p {
  margin: 5px 0;
  color: #333;
}

.logout-button {
  background-color: #ff4d4f;
}

.logout-button:hover {
  background-color: #ff7875;
}
</style>